import React, { useEffect, useState } from "react";

// components
import { Button, Input, FormGroup, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteConfirm from "components/AlertDelete/DeleteConfirm";

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// views
import DREExcecaoFicha from "./DREExcecaoFicha";
import ImportExcecoesDREcsv from "./ImportExecoesDREcsv";

// utils
import { showMessage } from "utils/message.js";
import { formateMesAno, formateDateByMesAno } from "utils/formats";
import { getSessionCookie } from 'utils/cookies';

// api
import usuario_api from "api/usuario_api.js";
import dreexcecoes_api from "api/dreexcecoes_api";


export default function DREExcecaoLista() {

  const [showLoading, setshowLoading] = React.useState(false);
  var session = getSessionCookie();
  const [startDate, setStartDate] = useState(formateDateByMesAno(session.mesAnoDefault));

  //===================================================================================CARREGA PERMISSÕES USUARIO================================================================================================//
  const [isDisable, set_isDisable] = useState(true);
  useEffect(() => {
    usuario_api.getFuncionalidadeAcaoLiberada("DREExcecoes", "Editar").then((result) => { set_isDisable(!result); });
  }, []);

  //===================================================================================FILTRAR DADOS================================================================================================//
  const [list_table, set_list_table] = React.useState([]);
  const handleClickFiltrar = () => {
    setshowLoading(true);
    dreexcecoes_api.getList(formateMesAno(startDate).replace("/", "-")).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        if (result.data.length > 0) {
          set_list_table(result.data);
        }
        else {
          showMessage("Aviso", "Não há Dre exceção gerado para este Mês/Ano", 'error', null);
          set_list_table([]);
        }

      }
    });
  }
  //=======================================================================================================================================================================================================//

  //===================================================================================DETALHES DRE EXCEÇÃO================================================================================================//
  const [dadosRowSelected, set_dadosRowSelected] = React.useState([]);
  const [openDialog, setopenDialog] = React.useState(false);
  function handleClickOpenDialog(rowData) {

    let row = list_table.filter(d => d.dreExcecaoID == rowData.dreExcecaoID);
    set_dadosRowSelected(row);
    setopenDialog(true);
  }
  function handleCloseDialog() {
    setopenDialog(false);
  }
  //=======================================================================================================================================================================================================//

  //===================================================================================NOVO DRE EXCEÇÃO================================================================================================//

  const [showAdd, set_showAdd] = React.useState(false);
  const handleAdd = () => {
    set_showAdd(true);
  }

  const handleReturn = () => {
    set_showAdd(false);
    handleClickFiltrar();
  }
  //=======================================================================================================================================================================================================//

  //===================================================================================DELETAR DRE EXCEÇÃO================================================================================================//
  const [showDelete, setshowDelete] = React.useState(false);
  const [selectedRowDataDelete, setselectedRowDataDelete] = React.useState(null);

  const handleClickDelete = (rowData) => {
    setselectedRowDataDelete(rowData.dreExcecaoID);
    setshowDelete(true);
  }
  const handleCloseDelete = () => {
    setshowDelete(false);
  }
  const handleConfirmDelete = () => {
    setshowDelete(false);

    setshowLoading(true);
    dreexcecoes_api.delete(selectedRowDataDelete).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        let newlist = list_table.filter(x => x.dreExcecaoID != selectedRowDataDelete);
        set_list_table(newlist);
        showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
      }
    });
  }

  //===================================================================================MODAL IMPORTAR CSV================================================================================================//

  const [openDialogCSV, setopenDialogCSV] = React.useState(false);

  function handleClickOpenDialogCSV() {
    setopenDialogCSV(true);

  }

  function handleCloseDialogCSV() {
    setopenDialogCSV(false);
  }
  //=======================================================================================================================================================================================================//

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showAdd ? "d-none" : "content"}>
        <Row>
          <Col lg="2" md="6" sm="12">
            <FormGroup>
              <label className="form-control-label">Mês/Ano</label>
              <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
            </FormGroup>
          </Col>
          <Col lg="2" md="6" sm="12" style={{ marginTop: "20px" }}>
            <Button color="info" type="button" onClick={handleClickFiltrar}><i className="fas fa-filter"></i> Filtrar</Button>
          </Col>
          <Col md="12" className="text-right">
            <Button onClick={handleClickOpenDialogCSV} variant="contained" size="small" color="success" style={{ margin: '15px' }}>
              Importar CSV
            </Button>
            {!isDisable && <Button color="default" onClick={handleAdd}><i className="fa fa-plus"></i>  Novo</Button>}
          </Col>
        </Row><br></br>
        {list_table.length > 0 &&
          <Form>
            <MaterialTable style={{ minHeight: "auto" }}
              title="Lista de Exceções"
              columns={[
                { title: 'Grupo Econômico', field: 'grupoEconomico' },
                { title: 'Loja', field: 'nickName' },
                { title: 'Cust Code', field: 'custCode' },
                { title: 'Mes Ano', field: 'mesAno' },
              ]}
              data={list_table}
              isLoading={false}
              actions={[
                {
                  icon: 'search',
                  tooltip: 'Visualizar Registro',
                  onClick: (event, rowData) => handleClickOpenDialog(rowData)
                },
                !isDisable &&
                {
                  icon: 'delete',
                  tooltip: 'Excluir Registro',
                  onClick: (event, rowData) => handleClickDelete(rowData)
                }
              ]}
              localization={table_translate}
              options={table_style}
            />
          </Form>
        }
      </div>

      {openDialog &&
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={openDialog}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            <h6 className="text-center">Dados DRE EXCEÇÃO</h6>
            <hr size="10"></hr>
          </DialogTitle>
          <DialogContent
            style={{ minHeight: "400px" }}
          >
            <div>
              <Row>
                <Col lg="12" md="12" sm="12">
                  <strong> Mês Ano: </strong> {dadosRowSelected[0].mesAno}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Regional: </strong> {dadosRowSelected[0].regional}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Grupo Econômico: </strong>{dadosRowSelected[0].grupoEconomico}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Loja: </strong> {dadosRowSelected[0].nickName}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Cust Code: </strong> {dadosRowSelected[0].custCode}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Usuário cadastro: </strong> {dadosRowSelected[0].usuario}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Data cadastro: </strong> {dadosRowSelected[0].datahora}<br></br><br></br>
                </Col>
                <Col lg="12" md="12" sm="12">
                  <strong> Motivo Exceção:</strong> {dadosRowSelected[0].motivoExcecao}<br></br><br></br>
                </Col>
              </Row>
            </div>
          </DialogContent>
          <DialogActions>
            <Button round color="secondary" autoFocus onClick={handleCloseDialog} >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      }

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={openDialogCSV}
        onClose={handleCloseDialogCSV}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Importar DRE Exceções - CSV<br></br>
          <hr size="10"></hr>
        </DialogTitle>
        <DialogContent
          style={{ minHeight: "400px" }}
        >
          <ImportExcecoesDREcsv />
        </DialogContent>
        <DialogActions>
          <Button round color="secondary" autoFocus onClick={handleCloseDialogCSV} >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {showAdd && <DREExcecaoFicha handleReturn={handleReturn}></DREExcecaoFicha>}

      {showDelete && <DeleteConfirm showDelete={showDelete} handleCloseDelete={handleCloseDelete} handleConfirmDelete={handleConfirmDelete}></DeleteConfirm>}

    </>
  );
}